<div class="rendered-component-item" [ngClass]="{'scaffold-read-hidden':item.read_hidden,'has-small-index-view':item.type === 'general_card' || item.type === 'list_card', 'hidden-in-index':_indexActive === false, 'show-comments':getCommentCount(item.name) > 0 || isActive()}">
  <span *ngIf="item.read_hidden" style="color:#ccc;" title="This section is not visible in the LMS"><i class="far fa-eye-slash"></i></span>
  <div class="scaffold-rendered-items {{paramprefix}}" [style]="(!info ? 'color:red;' : '')|safeStyle" *ngIf="info">

    <div [ngSwitch]="item.type" class="scaffold-item-content">

      <scaffold-course-archive-progress 
      [showPause]="true" [showBatchDetails]="true"
      *ngSwitchCase="'course_archive_progress'" [item]="item" [info]="info" [data]="data" [value]="item.value"></scaffold-course-archive-progress>
      
      
      <scaffold-tableau *ngSwitchCase="'tableau'" [item]="item" [info]="info" [data]="data" [value]="item.value"> </scaffold-tableau>


      <scaffold-email *ngSwitchCase="'email'" [item]="item" [info]="info" [data]="data" [value]="item.value"> </scaffold-email>

      <scaffold-heading *ngSwitchCase="'heading'" [item]="item" [info]="info" [data]="data" [value]="item.value"> </scaffold-heading>

      <scaffold-text *ngSwitchCase="'text'" [item]="item" [info]="info" [data]="data" [value]="item.value"></scaffold-text>

      <app-editable-text *ngSwitchCase="'edit_text'" [(ngModel)]="item.value" (input)="updateFromElement($event)" type="text" [item]="item"></app-editable-text>

      <scaffold-link *ngSwitchCase="'link'" [item]="item" [info]="info" [data]="data" [value]="item.value"> </scaffold-link>

      <ng-container *ngIf="!iframeService?.isInIframe">
      <scaffold-anchor *ngSwitchCase="'anchor'" [item]="item" [info]="info" [data]="data" [paramprefix]="paramprefix" [value]="item.value"> </scaffold-anchor>
       </ng-container>

       <scaffold-direct-link *ngSwitchCase="'direct_link'" [item]="item" [info]="info" [data]="data" [value]="item.value"></scaffold-direct-link>

      <scaffold-item-link *ngSwitchCase="'item_link'" [item]="item" [info]="info" [data]="data" [value]="item.value"></scaffold-item-link>

      <scaffold-file-link *ngSwitchCase="'file_link'" [item]="item" [info]="info" [data]="data" [paramprefix]="paramprefix" [value]="item.value"></scaffold-file-link>

      <hr *ngSwitchCase="'break'" />

      <scaffold-labeled-text *ngSwitchCase="'labeled_text'" [item]="item" [info]="info" [data]="data" [value]="item.value"></scaffold-labeled-text>

      <scaffold-panel *ngSwitchCase="'panel'" [item]="item" [info]="info" [data]="data" [paramprefix]="paramprefix" [value]="item.value"></scaffold-panel>

      <scaffold-conditional *ngSwitchCase="'conditional'" [item]="item" [info]="info" [data]="data" [paramprefix]="paramprefix" [value]="item.value"></scaffold-conditional>

      <scaffold-role-conditional *ngSwitchCase="'role_conditional'" [item]="item" [info]="info" [data]="data" [paramprefix]="paramprefix" [value]="item.value"></scaffold-role-conditional>

      <scaffold-create *ngSwitchCase="'create'" [item]="item" [info]="info" [data]="data" [value]="item.value"> </scaffold-create>

      <scaffold-data-link *ngSwitchCase="'data_link'" [item]="item" [info]="info" [data]="data" [value]="item.value"> </scaffold-data-link>

      <scaffold-data-link-count *ngSwitchCase="'data_link_count'" [item]="item" [info]="info" [data]="data" [value]="item.value"> </scaffold-data-link-count>

      <scaffold-data-link-label *ngSwitchCase="'data_link_label'" [item]="item" [info]="info" [data]="data" [value]="item.value"> </scaffold-data-link-label>

      <scaffold-text-link-label *ngSwitchCase="'text_link_label'" [item]="item" [info]="info" [data]="data"
                                [paramprefix]="paramprefix" [value]="item.value"> </scaffold-text-link-label>

      <scaffold-list *ngSwitchCase="'list'" [item]="item" [info]="info" [data]="data" style="position:relative;" [value]="item.value"> </scaffold-list>

      <scaffold-accordion *ngSwitchCase="'accordion'" [item]="item" [info]="info" [data]="data" [paramprefix]="paramprefix" [value]="item.value"></scaffold-accordion>

      <scaffold-tabs *ngSwitchCase="'tabs'" [item]="item" [info]="info" [data]="data" [paramprefix]="paramprefix" [value]="item.value"></scaffold-tabs>

      <scaffold-flex-row *ngSwitchCase="'flex'" [item]="item" [info]="info" [data]="data" [paramprefix]="paramprefix" [value]="item.value"></scaffold-flex-row>

      <scaffold-youtube *ngSwitchCase="'youtube'" [item]="item" [info]="info" [data]="data" [value]="item.value"></scaffold-youtube>

      <scaffold-iframe *ngSwitchCase="'iframe'" [item]="item" [info]="info" [data]="data" [value]="item.value"></scaffold-iframe>

      <scaffold-course-image *ngSwitchCase="'courseimage'" [item]="item" [info]="info" [data]="data" [value]="item.value"></scaffold-course-image>

      <scaffold-image *ngSwitchCase="'image'" [item]="item" [info]="info" [data]="data" [value]="item.value" (change)="update($event)"></scaffold-image>

      <scaffold-file-image *ngSwitchCase="'file_image'" [item]="item" [info]="info" [data]="data" [value]="item.value" (change)="update($event)"></scaffold-file-image>

      <app-outcomes *ngSwitchCase="'outcomesedit'" [data]="data" [item]="item" [info]="info"></app-outcomes>

      <scaffold-container *ngSwitchCase="'container'" [item]="item" [info]="info" [data]="data" [paramprefix]="paramprefix" [value]="item.value"></scaffold-container>

      <scaffold-well *ngSwitchCase="'well'" [item]="item" [info]="info" [data]="data" [paramprefix]="paramprefix" [value]="item.value"></scaffold-well>

      <app-block-styling *ngSwitchCase="'block_style'" [childview]="item.childview || childview" [info]="info" [item]="item" [data]="data" [paramprefix]="paramprefix" [value]="item.value"></app-block-styling>

      <scaffold-padding *ngSwitchCase="'padding'" [item]="item" [info]="info" [data]="data" [paramprefix]="paramprefix" [value]="item.value"></scaffold-padding>

      <scaffold-carousel *ngSwitchCase="'carousel'" [item]="item" [info]="info" [data]="data" [value]="item.value"></scaffold-carousel>

      <scaffold-row *ngSwitchCase="'row'" [item]="item" [info]="info" [data]="data" [paramprefix]="paramprefix" [value]="item.value"></scaffold-row>

      <!--Forms and inputs-->
      <scaffold-button *ngSwitchCase="'button'" [item]="item" [info]="info" [data]="data" [value]="item.value">

      </scaffold-button>
      <scaffold-view *ngSwitchCase="'view'" [item]="item" [info]="info" [data]="data" [value]="item.value"></scaffold-view>



      <scaffold-input *ngSwitchCase="'input'" [item]="item" [info]="info" [data]="data" (change)="update($event)" [value]="item.value"></scaffold-input>

      <scaffold-bulk-input *ngSwitchCase="'bulk_input'" [item]="item" [info]="info" [data]="data" [value]="item.value"></scaffold-bulk-input>


      <scaffold-switch *ngSwitchCase="'switch'" [item]="item" [info]="info" [data]="data" (change)="update($event)" [value]="item.value"></scaffold-switch>

      <scaffold-checkbox *ngSwitchCase="'check'" [item]="item" [info]="info" [data]="data" (change)="update($event)" [value]="item.value"></scaffold-checkbox>

      <scaffold-radio *ngSwitchCase="'radio'" [item]="item" [info]="info" [data]="data" (change)="update($event)" [value]="item.value"></scaffold-radio>

      <scaffold-hidden-default *ngSwitchCase="'hidden_default'" [item]="item" [info]="info" [data]="data" (change)="update($event)" [value]="item.value">
      </scaffold-hidden-default>

      <scaffold-select *ngSwitchCase="'select'" [item]="item" [info]="info" [data]="data" (change)="update($event)" [value]="item.value"></scaffold-select>
      <scaffold-select-list-display *ngSwitchCase="'select_list_display'" [item]="item" [info]="info" [data]="data" [value]="item.value"></scaffold-select-list-display>

      <app-time-picker *ngSwitchCase="'date'" [item]="item" [data]="data" [info]="info" (change)="update($event)" [value]="item.value"></app-time-picker>
      <scaffold-date-display *ngSwitchCase="'date_display'" [item]="item" [data]="data" [info]="info" [value]="item.value"></scaffold-date-display>

      <app-day-range-picker *ngSwitchCase="'weekday'" [item]="item" [data]="data" [info]="info" (change)="update($event)" [value]="item.value"></app-day-range-picker>

      <app-phone-number *ngSwitchCase="'phone_number'" [item]="item" [info]="info" [data]="data" (changed)="update($event)" [value]="item.value"></app-phone-number>

      <scaffold-editor *ngSwitchCase="'editor'" class="editor-in-view" [item]="item" [info]="info" [data]="data" (change)="update($event)" [value]="item.value"></scaffold-editor>

      <scaffold-navigation *ngSwitchCase="'navigation'" [item]="item" [info]="info" [data]="data" [value]="item.value"></scaffold-navigation>

      <scaffold-connection *ngSwitchCase="'connection'" [item]="item" [info]="info" [data]="data" [value]="item.value" (change)="update($event)"></scaffold-connection>

      <scaffold-form *ngSwitchCase="'form'" [item]="item" [info]="info" [data]="data" [value]="item.value"></scaffold-form>

      <scaffold-upload *ngSwitchCase="'upload'"></scaffold-upload>

      <app-file-manager *ngSwitchCase="'filebrowser'" [item]="item" [allowSelection]="false"></app-file-manager>

      <scaffold-wizard *ngSwitchCase="'wizard'" [item]="item" [info]="info" [data]="data" [paramprefix]="paramprefix" [value]="item.value"> </scaffold-wizard>

      <scaffold-template *ngSwitchCase="'template'" [item]="item" [info]="info" [data]="data" [value]="item.value"></scaffold-template>

      <scaffold-integration *ngSwitchCase="'integration'" [item]="item" [info]="info" [data]="data" (change)="update($event)" [value]="item.value"></scaffold-integration>

      <scaffold-file-view *ngSwitchCase="'attachment'" [item]="item"></scaffold-file-view>

      <scaffold-data *ngSwitchCase="'data'" [item]="item" [info]="info" [data]="data" [value]="item.value"></scaffold-data>

      <scaffold-learning *ngSwitchCase="'learningcomponent'" [item]="item" [info]="info" [data]="data"></scaffold-learning>

      <scaffold-data-search *ngSwitchCase="'data_search'" [item]="item" [info]="info" [data]="data" [value]="item.value"></scaffold-data-search>

      <scaffold-menu *ngSwitchCase="'menu'" [item]="item" [info]="info" [data]="data" [value]="item.value"></scaffold-menu>

      <scaffold-icon *ngSwitchCase="'icon'" class="icon-holder" [item]="item">
      </scaffold-icon>

      <scaffold-data-table *ngSwitchCase="'data_table'" [item]="item" [info]="info" [data]="data" [value]="item.value" (change)="update($event)"></scaffold-data-table>

      <scaffold-table-like-columns *ngSwitchCase="'table_like_columns'" [item]="item" [info]="info"></scaffold-table-like-columns>

      <scaffold-display-table *ngSwitchCase="'display_table'" [item]="item" [info]="info" [data]="data" [value]="item.value"></scaffold-display-table>

      <scaffold-data-visuals *ngSwitchCase="'data_visuals'" [item]="item" [info]="info" [data]="data" [value]="item.value"></scaffold-data-visuals>

      <scaffold-data-array *ngSwitchCase="'data_array'" [item]="item" [info]="info" [data]="data" [paramprefix]="paramprefix" [value]="item.value"></scaffold-data-array>

      <scaffold-template-data-array *ngSwitchCase="'template_data_array'" [item]="item" [info]="info" [data]="data" [paramprefix]="paramprefix" [value]="item.value"></scaffold-template-data-array>

      <app-customrendered *ngSwitchCase="'custom'" [item]="item"></app-customrendered>

      <app-listcard *ngSwitchCase="'list_card'" [item]="item" [info]="info" [indexActive]="_indexActive"></app-listcard>

      <app-general-card *ngSwitchCase="'general_card'" [item]="item" [info]="info" [value]="item.value"></app-general-card>

      <app-data-import *ngSwitchCase="'data_import'" [item]="item" [info]="info" data=[data] [value]="item.value"></app-data-import>

      <app-listindex *ngSwitchCase="'list_index'" [item]="item" [info]="info"></app-listindex>
      <app-lti-tool *ngSwitchCase="'lti_tool'" [item]="item" [info]="info" (change)="update($event)">
      </app-lti-tool>

      <app-up-next *ngSwitchCase="'up_next'"></app-up-next>
      <app-gradebook *ngSwitchCase="'gradebook'"  [info]="info" [item]="item"></app-gradebook>
      <app-mentions *ngSwitchCase="'mentions'" [item]="item"></app-mentions>

      <app-comment-filter *ngSwitchCase="'comment_filter'" [item]="item" [info]="info"></app-comment-filter>
      <app-comment-list *ngSwitchCase="'comment_list'" [item]="item" [info]="info"></app-comment-list>
      <scaffold-settings-panel *ngSwitchCase="'settings_panel'" [item]="item" [info]="info"></scaffold-settings-panel>
      <scaffold-json *ngSwitchCase="'scaffold_json'" [item]="item" [info]="info"></scaffold-json>
      <scaffold-user-instance-select *ngSwitchCase="'user_instance_select'" [item]="item" [info]="info"></scaffold-user-instance-select>
      <scaffold-rubric *ngSwitchCase="'rubric'" [item]="item" [info]="info"></scaffold-rubric>
      <scaffold-integration-status *ngSwitchCase="'integration_status'" [item]="item" [info]="info"></scaffold-integration-status>
      <div *ngSwitchDefault>
      </div>
    </div>
    <div class="comment-button" *ngIf="allowComments()" (mouseup)="setActiveComments($event);" [ngClass]="{'active-comment':isActive()}" [nbTooltip]="getCommentCount(item.name) + ' comments'">
      <nb-badge [text]="getCommentCount(item.name)" status="primary" position="top left" *ngIf="getCommentCount(item.name) > 0"></nb-badge>
      <nb-icon [status]="isActive() ? 'success':'info'" [pack]="getCommentClass('pack')" [icon]="getCommentClass('icon')" >
      </nb-icon>
    </div>
    <div>
    </div>
  </div>
</div>

